import { render } from "./wfm-source-type.vue?vue&type=template&id=f202edd4&scoped=true"
import script from "./wfm-source-type.vue?vue&type=script&lang=js"
export * from "./wfm-source-type.vue?vue&type=script&lang=js"

import "./wfm-source-type.vue?vue&type=style&index=0&id=f202edd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f202edd4"]])

export default __exports__